export const schoolsSelector = (state: any) => state.schools;
